module.exports = __webpack_public_path__ + "static/media/17@1280w.86a141d2.jpg";